import React, { useState, useEffect, useCallback } from "react";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { useLoading } from "../../../../context/LoadingContext";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../../Requirement/components/common/SearchFilter";
import {
  fetchData,
  postQuery,
  searchfetchQueries,
} from "../../../Requirement/services/RequirementServices";
import OfferDetails from "../../requirement/component/OfferDetails";
// import RFQDetailsReadOnly from "./components/RFQDetailsReadOnly";
import RFQForm from "./components/RFQForm";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import TrustScoreModal from "../../../../components/common/TrustScoreModal";

const RfqShortlistedOffers = ({ requirementDetails }) => {
  const navigate = useNavigate();
  const { setLoading, loading } = useLoading();
  const [offerList, setOfferList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [activeUser, setActiveUser] = useState("");
  const [error, setError] = useState(null);
  const [INRToUsd] = useState(0.012);

  const [rfqDetailsTabValue, setRfqDetailsTabValue] = useState(0);
  const [searchValues, setSearchValues] = useState({
    rfqNumber: "",
    searchProduct: "",
    searchProductGrade: "",
    searchQuantityRange: "",
  });

  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [allProductMaster, setAllProductMaster] = useState([]);
  const [buyerInfo, setBuyerInfo] = useState([]);
  const [selectedRFQ, setSelectedRFQ] = useState(null);

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });
  const quantityOptions = [
    { value: "", label: "Select Range" },
    { value: "50-100", label: "50-100 MT" },
    { value: "100-200", label: "100-200 MT" },
    { value: "200-500", label: "200-500 MT" },
    { value: "Above-500", label: "Above 500 MT" },
  ];
  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };
  const [firmOfferModal, setFirmOfferModal] = useState({
    show: false,
    offer: null,
    remarks: "",
  });

  // State for Verification Status Modal
  const [trustModal, setTrustModal] = useState(false);

  const trustModel = useCallback(() => {
    setTrustModal(true);
  }, []);

  const fetchOffers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const initialBody = {
        target: "listGPExtendedRequirementsItems",
        rowStart: 0,
        pageSize: 1,
        filterTerms: {
          CategoryType: "rfq",
          OfferStatus: "Shortlist",
          GPEmailID: activeUser,
          Deleted: 0,
        },
      };
      const initialResponse = await fetchData(initialBody);
      const totalCount = initialResponse?.total || initialResponse?.length || 0;
      let allOffers = [];
      if (totalCount > 0) {
        const fullBody = {
          ...initialBody,
          rowStart: 0,
          pageSize: totalCount,
        };
        const fullResponse = await fetchData(fullBody);
        allOffers = fullResponse.items || fullResponse || [];
      }

      // Apply client-side filters
      let filteredOffers = allOffers.filter((offer) => {
        if (
          searchValues.rfqNumber &&
          !offer.RequirementNumber?.toLowerCase().includes(
            searchValues.rfqNumber.toLowerCase()
          )
        ) {
          return false;
        }
        if (
          searchValues.searchProduct &&
          offer.ProductName !== searchValues.searchProduct
        ) {
          return false;
        }
        if (
          searchValues.searchProductGrade &&
          offer.Grade !== searchValues.searchProductGrade
        ) {
          return false;
        }
        if (searchValues.searchQuantityRange) {
          const quantity = parseFloat(offer.Quantity) || 0;
          const range = searchValues.searchQuantityRange;
          if (range === "Above-500") {
            return quantity > 500;
          } else {
            const parts = range.split("-");
            if (parts.length === 2) {
              const minStr = parts[0].trim();
              const maxStr = parts[1].trim();
              const min = parseFloat(minStr);
              const max = parseFloat(maxStr);
              if (!isNaN(min) && !isNaN(max)) {
                return quantity >= min && quantity <= max;
              }
            }
          }
          return false;
        }
        return true;
      });

      setTotalItems(filteredOffers.length);

      // Apply pagination to filtered results
      const start = rowStart;
      const end = start + pageSize;
      const paginatedOffers = filteredOffers.slice(start, end);
      setOfferList(paginatedOffers);
    } catch (error) {
      console.error("Error loading matching offers:", error);
      setError("Failed to load matching offers. Please try again.");
      setOfferList([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, [rowStart, pageSize, setLoading, activeUser, searchValues]);

  const fields = [
    {
      name: "rfqNumber",
      label: "RFQ Number",
      type: "text",
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, rfqNumber: value })),
      value: searchValues.rfqNumber,
    },
    {
      name: "searchProduct",
      label: "Product",
      type: "dropdown",
      options: productList.map((item) => ({
        value: item.ProductName,
        label: item.ProductName,
      })),
      value: searchValues.searchProduct,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchProduct: value }));
        if (value) {
          loadProductGrades(value);
        } else {
          setProductGradeList([]);
        }
      },
    },
    {
      name: "searchProductGrade",
      label: "Product Grade",
      type: "dropdown",
      options: productGradeList.map((item) => ({
        value: item.Grade,
        label: item.Grade,
      })),
      value: searchValues.searchProductGrade,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchProductGrade: value }));
      },
    },
    {
      name: "searchQuantityRange",
      label: "Quantity Range (MT)",
      type: "dropdown",
      options: quantityOptions,
      value: searchValues.searchQuantityRange,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchQuantityRange: value }));
      },
    },
  ];

  const handlePageChange = useCallback(
    (page) => {
      const newRowStart = (page - 1) * pageSize;
      setRowStart(newRowStart);
    },
    [pageSize]
  );

  const currentPage = Math.floor(rowStart / pageSize) + 1;
  const formatPrice = (value) => {
    if (!value || value === "") return "0.00";
    const numValue = parseFloat(value);
    return isNaN(numValue) ? "0.00" : numValue.toFixed(2);
  };

  const convertToUSD = (inrValue) => {
    if (!inrValue || inrValue === "") return "0.00";
    const usdValue = parseFloat(inrValue) * INRToUsd;
    return isNaN(usdValue) ? "0.00" : usdValue.toFixed(2);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const columns = [
    { id: "RequirementNumber", numeric: false, label: "RFQ Number" },
    { id: "ProductName", numeric: false, label: "Product" },
    { id: "Grade", numeric: false, label: "Grade" },
    {
      id: "Quantity",
      numeric: true,
      label: "Quantity (MT)",
      renderCell: (row) => formatPrice(row.Quantity),
    },
    {
      id: "CIFSalePrice",
      numeric: true,
      label: "CIF Sale Price",
      renderCell: (row) => convertToUSD(row.CIFSalePrice),
    },
    { id: "Country", numeric: false, label: "Origin Country" },
    { id: "DestinationCountry", numeric: false, label: "Destination" },
    { id: "INCO", numeric: false, label: "INCO Terms" },
    {
      id: "GPOOfferStatus",
      numeric: false,
      label: "Offer Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.GPOOfferStatus) {
          case "BAFO":
            bgColor = "#e0f2fe";
            textColor = "#0369a1";
            break;
          case "Firmoffer":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
            // row.OfferStatus = "Indicative"; // Set default status
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            {row.GPOOfferStatus}
          </span>
        );
      },
    },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Created Date",
      renderCell: (row) => formatDate(row.CreatedAt),
    },
    {
      id: "Expires",
      numeric: false,
      label: "Expires",
      renderCell: (row) => formatDate(row.Expires),
    },
    {
      id: "KYBStatus",
      numeric: false,
      label: "Seller Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.KYBStatus) {
          case "Approved":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
              display: "inline-block",
            }}
          >
            {row.KYBStatus === "Approved" ? "Verified" : "Unverified"}
          </span>
        );
      },
    },
  ];

  const getBuyerInfo = useCallback(async (buyerEmail) => {
    try {
      const response = await fetchData({
        target: "listAMTPLUsers",
        userOrder: "AMTPLUserID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { EmailID: buyerEmail },
      });
      setBuyerInfo(response.items || []);
    } catch (error) {
      console.error("Error loading buyer info:", error);
      setBuyerInfo([]);
    }
  }, []);

  const loadAllProducts = useCallback(async () => {
    setLoading(true);
    try {
      const [allProducts] = await Promise.all([
        searchfetchQueries({
          target: "listAllProducts",
          userOrder: "ProductID",
          rowStart: 0,
          pageSize: 1000,
        }),
      ]);
      setAllProductMaster(allProducts);
      const distinctProducts = Array.from(
        new Map(
          allProducts
            .filter((p) => p.productStatus === "ACTIVE") // ✅ Only include active products
            .map((p) => [p.ProductName, p])
        ).values()
      );
      setProductList(distinctProducts);
    } catch (error) {
      console.error("Error loading products: ", error);
      setAllProductMaster([]);
      setProductList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductName === productName
        );
        setProductGradeList(matchingProducts);
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allProductMaster]
  );

  const getRequirementDetails = useCallback(async (requirementsID) => {
    try {
      const response = await fetchData({
        target: "listRequirements",
        userOrder: "RequirementsID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { RequirementsID: requirementsID },
      });

      if (response.items && response.items.length > 0) {
        const rfq = response.items[0];

        setSelectedRFQ(rfq);
      }
    } catch (error) {
      console.error("Error fetching requirement details:", error);
      setSelectedRFQ(null);
    }
  }, []);
  // console.log('@@@@',requirementDetails);
  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
          await Auth.signOut();
          navigate("/login/global-partner");
        } else {
          setActiveUser(user.attributes.email);
          getBuyerInfo(user.attributes.email);
        }
      } catch (error) {
        console.error("Error checking user:", error);
        await Auth.signOut();
        navigate("/login/global-partner");
      }
    };
    checkUser();
  }, [navigate]);

  useEffect(() => {
    loadAllProducts();
  }, [ loadAllProducts]);

  useEffect(() => {
    if (activeUser) {
      getBuyerInfo(activeUser);
    }
  }, [activeUser, getBuyerInfo]);

  useEffect(() => {
    if (activeUser) {
      fetchOffers();
    }
  }, [activeUser, fetchOffers]);

  const handleRowClick = useCallback(
    (row) => {
      setSelectedOffer(row);
      console.log("row", row);
      getRequirementDetails(row.RequirementsID);
    },
    [getRequirementDetails]
  );

  const handleSearch = () => {
    setRowStart(0);
  };

  const handleRemoveOffer = async (offer) => {
    // if (
    //   !window.confirm(
    //     "Are you sure you want to remove this offer from your shortlist?"
    //   )
    // ) {
    //   return;
    // }
    setModal({
      show: true,
      type: "warning",
      title: "Are you sure?",
      message:
        "Are you sure you want to remove this offer from your shortlist?",
      isConfirm: true,
      onConfirm: async () => {
    setLoading(true);
    console.log("handleRemoveOffer triggered");
    console.log("removeOffer::", offer);
    try {
      // Simulate API call with a 1-second delay
      let body = null;
      console.log("Saving data to API:", offer);

      body = {
        target: "gpExtendedOfferUpdate",
        GPOfferExtendedInput: {
          GPOfferExtendedID: offer.GPOfferExtendedID,
          Deleted: 1,
        },
      };

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Offer removed successfully!`,
            autoClose: false,
            nextAction: () => {
              // sendTrueToParent();
              setSelectedOffer(null);
            },
          });
        }
      }

      // Refresh the table data
      setSelectedOffer(null);
      // Reload the table
      await fetchOffers();
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Failed to remove from shortlist offer. Please try again.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
    },
      onCancel: () => setModal((prev) => ({ ...prev, show: false })),
    });
  };

  const handleNegotiate = async (offer) => {
    setLoading(true);
    console.log("handleNegotiate triggered");
    console.log("negotiateOffer::", offer);
    try {
      // Simulate API call with a 1-second delay
      let body = null;
      console.log("Saving data to API:", offer);

      body = {
        target: "gpExtendedOfferUpdate",
        GPOfferExtendedInput: {
          // Deleted: 0,
          OfferStatus: "Firmoffer",
          GPOfferExtendedID: offer.GPOfferExtendedID,
        },
      };

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Send Firm Offer successfully!`,
            autoClose: false,
            nextAction: () => {
              setSelectedOffer(null);
            },
          });
        }
      }

      // Refresh the table data
      await fetchOffers();
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Failed to send firm offer. Please try again.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const Button = ({ label, onClick }) => {
    return (
      <button
        className="btn-action-re"
        onClick={onClick}
        style={{ width: "140px" }}
      >
        {label}
      </button>
    );
  };
 const handleSendffer = (offer, type) => {
    setFirmOfferModal({
      show: true,
      offer: offer,
      remarks: "",
      type: type,
    });
  };
  // Pass the selectedOffer ID to DataTable via selectedRows
  const selectedRows = selectedOffer
    ? [selectedOffer.GPOfferID || selectedOffer.id]
    : [];
  const handleFirmOfferCancel = () => {
    setFirmOfferModal({
      show: false,
      offer: null,
      remarks: "",
    });
  };
  const handleSaveExtendedOffer = async (offer, OfferStatus) => {
      setLoading(true);
  console.log(offer,selectedOffer)
      try {
        let body = {
          target: "gpShortlistOffer",
          GPOfferExtendedInput: {
            GPOfferID: offer.GPOfferID,
            OfferStatus: "Query",
            Remarks: firmOfferModal.remarks,
            Margin: offer.Margin,
            CategoryType: "rfq",
            GPEmailID: activeUser,
            RequirementsID: offer.RequirementsID,
          },
        };
  
        console.log("Saving body to API:", body);
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
  
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Query sent successfully!`,
            autoClose: false,
            nextAction: () => {
              setSelectedOffer(null);
               fetchOffers();
            },
          });
        }
      } catch (error) {
        console.error("Error saving data:", error);
        setModal({
          show: true,
          type: "error",
          title: "Error",
          message: `Failed to send ${
            OfferStatus === "BAFO"
              ? "BAFO"
              : OfferStatus === "Query"
              ? "query"
              : "firm offer"
          }. Please try again.`,
          autoClose: false,
        });
      } finally {
        setLoading(false);
      }
    };
    const handleOfferSubmit = async () => {
      console.log(firmOfferModal)
    if (firmOfferModal.offer) {
      await handleSaveExtendedOffer(firmOfferModal.offer, firmOfferModal.type);
      setFirmOfferModal({
        show: false,
        offer: null,
        remarks: "",
      });
      //await fetchOffers(searchValues, rowStart);
    }
  };
  return (
    <div className="matching-offers-container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="table-header">
        <div className="header-text">
          <div className="head-text">Shortlisted Offers</div>
        </div>
        <div className="head-btn"></div>
      </div>
      <div className="search-filter row">
        <SearchFilter fields={fields} onSearch={handleSearch} />
      </div>
      {loading && <div className="loading">Loading offers...</div>}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && offerList.length === 0 && (
        <div className="empty-state">No matching offers found.</div>
      )}
      {!loading && offerList.length > 0 && (
        <DataTable
          columns={columns}
          data={offerList}
          total={totalItems}
          title="Matching Offers Information"
          rowsPerPage={pageSize}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          onRowClick={handleRowClick}
          selectedRows={selectedRows} // Pass selected row ID
        />
      )}
      {selectedOffer && (
        <>
          {/* Offer Details Section */}
          <div className="offer-detail1">
            <div className="header-text-re">
              <div className="head-text">Offer Details</div>
              <div className="button-group">
                <Button label="Verification Status" onClick={trustModel} />
                <Button
                  label="Remove"
                  onClick={() => handleRemoveOffer(selectedOffer)}
                />
                <Button
                  label="Send Firm Offer"
                  onClick={() => handleNegotiate(selectedOffer)}
                />
                <Button
                 onClick={() => handleSendffer(selectedOffer, "Query")}
                label="Ask seller a question" />
              </div>
            </div>
            {
              <OfferDetails
                offer={selectedOffer}
                btnShortlist={false}
                btnSendQuery={false}
                btnRequestQuote={false}
                btnRequestSpecifications={false}
                btnRequestBestPrice={false}
                btnNegotiate={false}
                btnRequestShippingDetails={false}
                btnLogisticsSupport={false}
                btnRaiseQuery={true}
              />
            }
          </div>

          {/* RFQ Details Section */}
          {selectedOffer && selectedOffer.RequirementsID && (
            // <RFQDetailsReadOnly
            //   selectedOffer={selectedOffer}
            //   tabValue={rfqDetailsTabValue}
            //   setTabValue={setRfqDetailsTabValue}
            // />
            <RFQForm
              formMode="view"
              setFormMode={true}
              selectedRFQ={selectedRFQ}
              setIsFormVisible={true}
              productList={productList}
              allProductMaster={allProductMaster}
              btnCancel={false}
            />
          )}
        </>
      )}
      {firmOfferModal.show && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              width: "500px",
              maxWidth: "90vw",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              className="modal-header"
              style={{
                marginBottom: "20px",
                borderBottom: "1px solid #e5e7eb",
                paddingBottom: "16px",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#1f2937",
                }}
              >
                {firmOfferModal.type === "BAFO"
                  ? "Send BAFO"
                  : firmOfferModal.type === "Query"
                  ? "Ask seller a question"
                  : "Send Firm Offer"}
              </h3>
            </div>

            <div className="modal-body" style={{ marginBottom: "24px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#374151",
                }}
              >
                Remarks
              </label>
              <textarea
                value={firmOfferModal.remarks}
                onChange={(e) =>
                  setFirmOfferModal((prev) => ({
                    ...prev,
                    remarks: e.target.value,
                  }))
                }
                placeholder="Enter your remarks here..."
                rows={4}
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                  resize: "vertical",
                  outline: "none",
                  fontFamily: "inherit",
                }}
              />
            </div>

            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <button
                onClick={handleFirmOfferCancel}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #d1d5db",
                  backgroundColor: "white",
                  color: "#374151",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleOfferSubmit}
                className="submit-btn-more"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Verification Status Modal */}
      {trustModal && selectedOffer && (
        <TrustScoreModal
          onClose={() => setTrustModal(false)}
          userEmail={selectedOffer.SellerEmailID}
        />
      )}
    </div>
  );
};

export default RfqShortlistedOffers;
